import { Badge, Box, SkeletonGroup, SkeletonRectangle, Text } from '@wix/design-system';
import { CoreDomainSearchStore } from '@wix/domains-search-suite';
import React, { forwardRef } from 'react';
import s from './BngDomainSuggestionsHeadingV2.scss';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import { StepCircleHeading } from '../../../../Components/StepCircleHeading';
import { useIsMobile } from '../../../../hooks/useIsMobile';
import { BngDomainSuggestionsDataHooks } from './dataHooks';
const SelectedNameSlot = _ref => {
  let isLoading = _ref.isLoading,
    isMobile = _ref.isMobile,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("span", {
    className: s.selectedNameSlot
  }, isLoading ? /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light",
    className: s.selectedNameBadgeSkeleton
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true,
    className: s.selectedNameBadgeBaselineShim
  }, '​'), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    width: isMobile ? '88px' : '133px',
    height: "24px"
  })) : /*#__PURE__*/React.createElement(Badge, {
    type: "outlined",
    size: "small",
    skin: "premium",
    uppercase: false,
    className: s.selectedNameBadge,
    dataHook: BngDomainSuggestionsDataHooks.selectedNameBadge
  }, children));
};
const BngDomainSuggestionsHeadingV2 = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let isLoading = _ref2.isLoading;
  const query = CoreDomainSearchStore.useQuery();
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    Trans = _DomainSearchGateModu.Trans;
  const isMobile = useIsMobile();
  const nameSuggestion = query.trim();
  if (!isLoading && !nameSuggestion) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    direction: "horizontal",
    gap: "SP2",
    verticalAlign: "middle",
    paddingBottom: "0px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(StepCircleHeading, {
    step: 2
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal",
    tagName: "h2",
    className: s.heading,
    dataHook: BngDomainSuggestionsDataHooks.domainSuggestionsTitle
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_gate.bng_results.step_2.choose_domain.title",
    values: {
      nameSuggestion
    },
    shouldUnescape: true,
    components: [/*#__PURE__*/React.createElement(SelectedNameSlot, {
      isLoading: isLoading,
      isMobile: isMobile
    })]
  }))));
});
export default BngDomainSuggestionsHeadingV2;
//# sourceMappingURL=BngDomainSuggestionsHeadingV2.js.map